import QueueStats from "./QueueStats";
import { Grid } from "@material-ui/core";
import { count } from "rxjs/operators";
import { FilterCalls } from "../../helpers/callFilter";

function QueueStatsAll(props) {

    let totalReady = 0;
    let totalNotReady = 0;

    return (
        <>
            <Grid item style={{display: "flex", alignItems: "center", flexGrow: 4, paddingLeft: "15px", maxWidth: "200px", width: "100%"}}>
                <Grid>
                    Total Calls
                </Grid>
            </Grid>
        {
            props.queues.map(q => {

                            //get a count of things from each call queue
                            let queue = props.calls.find(cq => cq.Name.toLowerCase() === q.replaceAll(' ', '').toLowerCase() );
                            //If the filter is set to all
                            let counts = {
                                Ready: 'Loading',
                                NotReady: 'Loading'
                            };
                            if (queue) {
                                let calls = [];
                                if (props.useConfig) {
                                    calls = FilterCalls(props.config, queue.contacts || [])
                                } else {
                                    calls = queue.contacts || [];
                                }
                                let r = calls.filter(call => {
                                    return Date.parse(call.CallTime) < Date.now();
                                })
                                let nr = calls.filter(call => {
                                    return Date.parse(call.CallTime) > Date.now();
                                })

                                counts.Ready = r.length;
                                counts.NotReady = nr.length;
                                totalReady += counts.Ready;
                                totalNotReady += counts.NotReady;
                            }
                            return <QueueStats showLabel={true} counts={counts} label={q} key={q} />
                        })
        }
        <QueueStats showLabel={true} counts={{Ready: totalReady, NotReady: totalNotReady}} label={"Totals"} key={`${props.worker}-total`} />
        </>
    )
}

export default QueueStatsAll;